module.exports = __webpack_public_path__ + "static/p1-a51280ca772e76fccc24595a711503cd.png";